// extracted by mini-css-extract-plugin
export default {"main":"showcase_main__RcCOY","img":"showcase_img__-H95g","title":"showcase_title__5wEaI","paraContainer":"showcase_paraContainer__SJSkN"};